import {useState, useEffect} from 'react'

// Icons
import { FaBars } from "react-icons/fa6";
import { IoClose } from "react-icons/io5";
import { FaToggleOff } from "react-icons/fa6";
import { FaToggleOn } from "react-icons/fa6";

const Header = () => {
  const[showMenu, setShowMenu] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(false);

  // Toggle dark/light theme
  const toggleTheme = () => {
    setIsDarkMode(!isDarkMode);
  };

  // Apply dark or light theme to the document
  useEffect(() => {
    if (isDarkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [isDarkMode]);

  return (
    <div className='header'>
        
        {/* Logo Element */}
        <div className='logo'>Aman.dev</div>

        {/* Navigation */}
        <ul className={showMenu ? 'nav' : 'nav hideNav'} data-testid="nav">
          <a href='#Home' className='navLink' onClick={()=>setShowMenu(false)}><li>Home</li></a>
          <a href='#About' className='navLink' onClick={()=>setShowMenu(false)}><li>About</li></a>
          <a href='#Skills' className='navLink' onClick={()=>setShowMenu(false)}><li>Skills</li></a>
          <a href='#Projects' className='navLink' onClick={()=>setShowMenu(false)}><li>Projects</li></a>
          {/* <a href='#Testimony' className='navLink' onClick={()=>setShowMenu(false)}><li>Testimony</li></a> */}
          <a href='#Experience' className='navLink' onClick={()=>setShowMenu(false)}><li>Experience</li></a>
          <a href='#Readiness' className='navLink' onClick={()=>setShowMenu(false)}><li>My Remote</li></a>
          <a href='#Contact' className='navLink' onClick={()=>setShowMenu(false)}><li>Contact</li></a>
          
          <IoClose className='closeMenu' alt='close' onClick={()=>setShowMenu(false)}/>
        </ul>

        {/* Menu Bar */}
        <div className='leftMenus'>
          <FaBars className='showMenu' alt='bar' onClick={()=>setShowMenu(true)}/>
          <div className="themeToggle" onClick={toggleTheme}>
            {isDarkMode ? <FaToggleOn /> : <FaToggleOff />}
          </div>
        </div>
    </div>
  )
}

export default Header